"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.testimonials =
  twentyninetimes.testimonials ||
  (function () {
    function init() {
      const testimonials = document.querySelectorAll(".testimonials");

      if (testimonials) {
        testimonials.forEach((block) => {
          let slideIndex = 0;
          const nextBtn = block.querySelector(".swiper-next");
          const prevBtn = block.querySelector(".swiper-prev");
          const countCurrent = block.querySelector(".count-current");
          const countTotal = block.querySelector(".count-total");
          const backgroundContainer = block.querySelector(".testimonials-bg");
          const slides = block.querySelectorAll(".swiper-slide");
          const slideContainer = block.querySelector(".swiper-wrapper");

          if (slides) {
            slides.forEach((slide) => {
              const dialog = slide.querySelector("dialog");
              const slideInfo = slide.querySelector(".swiper-slide-info");
              const playButton = slide.querySelector(".play-button");
              const closeButton = dialog.querySelector(".close-button");
              const videoFrame = slide.querySelector("iframe");
              const player = new Vimeo.Player(videoFrame);

              playButton.onclick = () => {
                dialog.showModal();
                document.addEventListener("keyup", function escListener(e) {
                  if (e.key === "Escape" || e.key === "ESC") {
                    dialog.close();
                    player.pause();
                    // clean up
                    document.removeEventListener("keyup", escListener);
                  }
                });
              };

              closeButton.onclick = () => {
                dialog.close();
                player.pause();
              };

              slideInfo.onclick = () => {
                slideIndex = slide.dataset.index;
                setTranslateX(slides, slideContainer, slideIndex);
                setBackground(slides, slideIndex, backgroundContainer);
                setActiveSlideClass(slides, slideIndex);
                updateSlideOpacity(slides, slideIndex);
                checkSlideEnd(slides, slideIndex, prevBtn, nextBtn);
                setCount(countCurrent, slideIndex);
              };
            });
          }

          nextBtn.onclick = () => {
            if (slideIndex < slides.length - 1) {
              slideIndex++;
              setTranslateX(slides, slideContainer, slideIndex);
              setBackground(slides, slideIndex, backgroundContainer);
              setActiveSlideClass(slides, slideIndex);
              checkSlideEnd(slides, slideIndex, prevBtn, nextBtn);
              setCount(countCurrent, slideIndex);
            }
          };

          prevBtn.onclick = () => {
            if (slideIndex - 1 >= 0) {
              slideIndex--;
              setTranslateX(slides, slideContainer, slideIndex);
              setBackground(slides, slideIndex, backgroundContainer);
              setActiveSlideClass(slides, slideIndex);
              checkSlideEnd(slides, slideIndex, prevBtn, nextBtn);
              setCount(countCurrent, slideIndex);
            }
          };

          countTotal.textContent = slides.length;
          checkSlideEnd(slides, slideIndex, prevBtn, nextBtn);
          setBackground(slides, slideIndex, backgroundContainer);
          setCount(countCurrent, slideIndex);
          setActiveSlideClass(slides, slideIndex);
          // slideContainer.addEventListener('scroll', handleScroll(slides, slideContainer));
        });

        // functions
        function setBackground(slides, index, backgroundContainer) {
          if (slides) {
            const bgUrl = slides[index].getAttribute("data-bg");
            backgroundContainer.style.backgroundImage = `url(${bgUrl})`;
          }
          updateSlideOpacity(slides, index);
        }

        function setCount(countEl, index) {
          countEl.textContent = parseInt(index) + 1;
        }

        function setTranslateX(slides, slideContainer, index) {
          let totalWidth = 0;
          for (let i = 0; i < index; i++) {
            console.log(slides[i].offsetWidth);
            totalWidth += slides[i].offsetWidth;
          }
          slideContainer.style.transform = `translateX(-${totalWidth}px)`;
        }

        function setActiveSlideClass(slides, index) {
          slides.forEach((slide, i) => {
            slide.classList.remove("active");
            if (i == index) {
              slide.classList.add("active");
            }
          });
        }

        function checkSlideEnd(slides, index, prevBtn, nextBtn) {
          if (index == 0) {
            prevBtn.classList.add("disabled");
          } else {
            prevBtn.classList.remove("disabled");
          }

          if (index + 1 == slides.length) {
            nextBtn.classList.add("disabled");
          } else {
            nextBtn.classList.remove("disabled");
          }
        }

        function handleScroll(slides, slideContainer) {
          const slideWidth = slides[0].offsetWidth;
          const index = Math.round(slideContainer.scrollLeft / slideWidth);
          updateSlideOpacity(slides, index);
        }

        function updateSlideOpacity(slides, index) {
          slides.forEach((slide, i) => {
            let opacity = 1;
            if (i <= index - 2 || i > index + 2) {
              opacity = 0;
            } else if (i === index) {
              opacity = 1;
            } else {
              opacity = 0.35;
            }

            slide.style.opacity = opacity;
          });
        }
      }
    }

    return {
      init: init,
    };
  })();
